import { css } from 'lit';
export const componentStyles = css `
    :host {
        box-sizing: border-box;
    }

    :host *,
    :host *::before,
    :host *::after {
        box-sizing: inherit;
    }

    [hidden] {
        display: none !important;
    }

    .hlx-hidden {
        display: none;
    }

    @media (prefers-reduced-motion) {
        .hlx-animation-with-prefers-reduced-motion,
        .hlx-animation-with-prefers-reduced-motion::after,
        .hlx-animation-with-prefers-reduced-motion::before {
            animation: none !important;
            transition: none !important;
        }
    }
`;
//# sourceMappingURL=component.styles.js.map